/**
 * Simple method for reading API values that are intended to be numerical or null.
 * Used mainly to hydrate values from the API.
 * @param value
 * @return {*}
 */
export default function parseNumerical(value) {
    if (value === null) {
        return null;
    }
    const parsed = Number(value);
    return isNaN(parsed) ? value : parsed;
}
